import { Button } from '@c1/gravity-react';
import React, { useEffect, useState } from 'react';
import RouteBuilder from 'src/utils/routing/RouteBuilder';
import { useRouteBuilder } from 'src/utils/routing/RouteBuilderContext';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import {
  AuthenticationContextState,
  useAuthenticationContext
} from 'src/contextProviders/AuthenticationProvider/AuthenticationContext';
import "./QuicksightDashboard.css";
import axios from 'axios';
import { navigate, useLocation, useParams } from '@reach/router';
import iframeResolutionHelper from 'src/utils/iframeResolutionHelper';
import { GetQuicksightBoardInfoResponse } from 'src/types/apiResponse';
import EmbeddedFrame from 'src/components/EmbeddedFrame/EmbeddedFrame';
import { createEmbeddingContext, EmbeddingContext } from 'amazon-quicksight-embedding-sdk';



function QuicksightDashboard(): FunctionComponentReturnType {
  const [didUrlRequestFail, setDidUrlRequestFail] = useState<boolean>(false);
  const routeBuilder: RouteBuilder = useRouteBuilder();
  const [errorOnEmbedView, setErrorOnEmbedView] = useState<boolean>(false);
  const { pinboardId } = useParams();
  const location = useLocation();
  const { user }: AuthenticationContextState = useAuthenticationContext();
  const apiRouteGetQuicksightBoardInfo: string = routeBuilder.api.getQuicksightBoardInfo({ dashboardId: pinboardId });


  useEffect(function() {
    async function loadDashboard() {
      if (document.getElementById("page-template-title-element")) {
         document.getElementById("page-template-title-element").textContent = "...";
      }
      const embeddingContext: EmbeddingContext = await createEmbeddingContext({
          onChange: (changeEvent) => { console.log('Context received a change', changeEvent); }
      });
      const { embedDashboard, embedVisual, embedConsole, embedQSearchBar } = embeddingContext;
      axios.get<GetQuicksightBoardInfoResponse>(apiRouteGetQuicksightBoardInfo).then(async function (response) {
          if(response.status == 200) {
              let tempAnonUrl = response.data.dashboardUrl;
              if(tempAnonUrl && (/^https:\/\/us-[a-z]+-[1-9]\.quicksight\.aws\.amazon\.com\/embed/).test(tempAnonUrl)) {
                  if (document.getElementById("page-template-title-element")) {
                      document.getElementById("page-template-title-element").textContent = response.data.dashboardName;
                  }
                  const frameOptions = {
                    url: tempAnonUrl,
                    height: "80%",
                    resizeHeightOnSizeChangedEvent: true,
                    container: document.getElementById("quicksight-container"),
                    withIframePlaceholder: true
                  };
                  const embeddedDashboardExperience = await embedDashboard(frameOptions, {});
              }
              else {
                  setDidUrlRequestFail(true);
              }
          }
        }).catch(function (error) {
          setDidUrlRequestFail(true);
        });
    }
    loadDashboard();
  }, [setDidUrlRequestFail]);


  return (
    <div id={'quicksight-page-body'}>
      <Button id={'copp-button-return'} className="grv-margin--tiny" type="regressive" onClick={() => navigate(routeBuilder.client.toDashboardSelectionPage())} compact>Return</Button>
      <br />
        {didUrlRequestFail? <div>Failed to load the dashboard</div> : null}
         <div id="quicksight-container" className={"quicksight-container"} >
        </div>
    </div>
  );
}

export default QuicksightDashboard;
